import { Screens } from '../../redux/types';
import { NotAMinorTermination } from './demographics/not-a-minor-termination';
import { CompletedByMinorTermination } from './demographics/completed-by-minor-termination';
import ConsentForMinor from './demographics/consent-for-minor';
import DemographicsForm from './demographics/demographics-form';
import GuardianDemographicsForm from './demographics/guardian-demographics-form';
import { OutOfCoverage } from './demographics/out-of-coverage';
import PreviouslyCompleted from './demographics/previously-completed';
import Final from './matching/final';
import FinalChoseNoMatch from './matching/final-chose-no-match';
import GetStarted from './introduction/get-started';
import Introduction from './introduction/introduction';
import AppointmentConfirmation from './matching/appointment-confirmation';
import MatchingList from './matching/list';
import InNetwork from './medical-info/in-network';
import NotInNetwork from './medical-info/not-in-network';
import MedicationPharmacy from './medical-info/medication-pharmacy';
import MedicalInfoQuestion from './medical-info/question';
import PatientType from './demographics/patient-type';
import StateCheck from './demographics/state-check';
import Review from './preferences/review';
import Emergency from './reason-visit/emergency';
import NoService from './reason-visit/no-service';
import ReasonVisitQuestion from './reason-visit/question';
import SensitiveInformationWarning from './reason-visit/sensitive-information-warning';
import CollectEmail from './verify-email/collect-email';
import ConfirmEmail from './verify-email/confirm-email';
import PrimaryPolicyHolder from './medical-info/primary-policyholder';
import LandingRouter from './introduction/landing-router';
import ConsentReferrerSharing from './demographics/consent-referrer-sharing';
import InsuranceForm from './medical-info/insurance-form';
import EmergencyContactForm from './medical-info/emergency-contact-form';
import InsuranceId from './medical-info/insurance-id';
import ZocdocIntroductionFirst from './introduction/zocdoc-introduction-first';
import ZocdocIntroductionSecond from './introduction/zocdoc-introduction-second';
import IntroScreenOne from './introduction/intro-screen-one';
import IntroScreenTwo from './introduction/intro-screen-two';
import IntroScreenThree from './introduction/intro-screen-three';
import IntroScreenFour from './introduction/intro-screen-four';
import { MatchLoading } from './matching/match-loading';
import PersonalDetails from './demographics/personal-details';
import MedicalInfoIntro from './medical-info/medical-info-intro';
import InsuranceComboForm from './medical-info/insurance';

const getCurrentAssessmentComponent = (screen: Screens) => {
  switch (screen) {
    case Screens.LandingRouter:
      return LandingRouter;
    case Screens.Introduction:
      return Introduction;
    case Screens.IntroScreenOne:
      return IntroScreenOne;
    case Screens.IntroScreenTwo:
      return IntroScreenTwo;
    case Screens.IntroScreenThree:
      return IntroScreenThree;
    case Screens.IntroScreenFour:
      return IntroScreenFour;
    case Screens.GetStarted:
      return GetStarted;
    case Screens.ZocdocIntroductionFirst:
      return ZocdocIntroductionFirst;
    case Screens.ZocdocIntroductionSecond:
      return ZocdocIntroductionSecond;
    case Screens.CollectEmail:
      return CollectEmail;
    case Screens.ConfirmEmail:
      return ConfirmEmail;
    case Screens.PreviouslyCompleted:
      return PreviouslyCompleted;
    case Screens.PatientType:
      return PatientType;
    case Screens.PersonalDetails:
      return PersonalDetails;
    case Screens.StateCheck:
      return StateCheck;
    case Screens.CollectDemographics:
      return DemographicsForm;
    case Screens.ConsentReferrerSharing:
      return ConsentReferrerSharing;
    case Screens.ConsentForMinor:
      return ConsentForMinor;
    case Screens.GuardianDemographics:
      return GuardianDemographicsForm;
    case Screens.OutOfCoverage:
      return OutOfCoverage;
    case Screens.CompletedByMinorTermination:
      return CompletedByMinorTermination;
    case Screens.NotAMinorTermination:
      return NotAMinorTermination;
    case Screens.RV_MainReason:
      return ReasonVisitQuestion;
    case Screens.RV_SecondaryReason:
      return ReasonVisitQuestion;
    case Screens.RV_SpecialtyCare:
      return ReasonVisitQuestion;
    case Screens.RV_UseOfDrugs:
      return ReasonVisitQuestion;
    case Screens.RV_DrinkingAlcohol:
      return ReasonVisitQuestion;
    case Screens.RV_KillingYourself:
      return ReasonVisitQuestion;
    case Screens.RV_PsychiatricImpatient:
      return ReasonVisitQuestion;
    case Screens.SensitiveInformationWarning:
      return SensitiveInformationWarning;
    case Screens.Emergency:
      return Emergency;
    case Screens.NoService:
      return NoService;
    case Screens.MedicalInfoIntro:
      return MedicalInfoIntro;
    case Screens.MI_InsuranceCombo:
      return InsuranceComboForm;
    case Screens.MI_InsuranceForm:
      return InsuranceForm;
    case Screens.MI_InsuranceId:
      return InsuranceId;
    case Screens.MI_PrimaryPolicyHolder:
      return PrimaryPolicyHolder;
    case Screens.NotInNetwork:
      return NotInNetwork;
    case Screens.MI_MedicationPharmacyCombo:
      return MedicationPharmacy;
    case Screens.InNetwork:
      return InNetwork;
    case Screens.MI_HaveAppointment:
      return MedicalInfoQuestion;
    case Screens.MI_EmergencyContact:
      return EmergencyContactForm;
    case Screens.Review:
      return Review;
    case Screens.MatchLoading:
      return MatchLoading;
    case Screens.List:
      return MatchingList;
    case Screens.NoMatch:
      return FinalChoseNoMatch;
    case Screens.AppointmentConfirmation:
      return AppointmentConfirmation;
    case Screens.Finish:
      return Final;
    default:
      return Introduction;
  }
};

type PropTypes = {
  screen: Screens;
};

const CurrentAssessmentComponent = ({ screen }: PropTypes) => {
  const Component = getCurrentAssessmentComponent(screen);
  return <Component />;
};

export default CurrentAssessmentComponent;

export { default as DevControls } from './dev-controls';
